<!-- Energy widget version: 1.0 -->
<script lang="ts">
	import EmWidgetState from 'src/components/EnergyMonitoring/EmWidgetState.svelte';
	import { getActivePvSetupType } from 'src/components/EnergyMonitoring/helpers/pv_flow_helpers';
	import { getPVSetupDevices } from 'src/components/Consumption/PVSetupEnergy/pv_setup_helper';
	import { energyMonitoringDataMode } from 'src/components/EnergyMonitoring/helpers/store';
	import { ENERGY_PV_SETTINGS_HREF } from 'src/components/EnergyMonitoring/helpers/energy_widget_state_helpers';
	import PVSetupEnergyDistribution from 'src/components/Consumption/PVSetupEnergy/PVSetupEnergyDistribution.svelte';
	import { Container } from '@Shelly/shelly-design-system';
	import { format } from 'svelte-i18n';
	import type { DashEnergyWidgetConfig } from 'src/components/Dashboards/dash-energy-types';

	export let energyConfig: DashEnergyWidgetConfig | undefined;
	export let staticPreview = false;

	$: void energyConfig;
	$: pvSetupType = getActivePvSetupType();
	$: pvSetupDevices = getPVSetupDevices(pvSetupType);
	$: hasCompletePvSetup =
		pvSetupDevices.gridDevices.length > 0 && pvSetupDevices.solarDevices.length > 0;
	$: useDemoData = staticPreview || $energyMonitoringDataMode === 'demo';
</script>

<Container type="glass" noScroll fullHeight>
	{#if staticPreview || useDemoData || hasCompletePvSetup}
		<PVSetupEnergyDistribution {pvSetupType} {staticPreview} embedded />
	{:else}
		<EmWidgetState
			kind="setup"
			message={$format('energy_monitoring_pv_setup_missing', {
				default: 'Set up grid and solar meters to see live PV energy.',
			})}
			minHeight="220px"
			actionHref={ENERGY_PV_SETTINGS_HREF}
			actionLabel={$format('energy_monitoring_pv_configure', { default: 'Set up PV' })}
		/>
	{/if}
</Container>
